var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99926 13H20.0007C20.5503 13 21 12.55 21 12C21 11.45 20.5503 11 20.0007 11H3.99926C3.44967 11 3 11.45 3 12C3 12.55 3.44967 13 3.99926 13ZM3.99926 19H12.348C12.8975 19 13.3472 18.55 13.3472 18C13.3472 17.45 12.8975 17 12.348 17H3.99926C3.44967 17 3 17.45 3 18C3 18.55 3.44967 19 3.99926 19ZM3 6C3 6.55 3.44967 7 3.99926 7H19.9903C20.5399 7 20.9896 6.55 20.9896 6C20.9896 5.45 20.5399 5 19.9903 5H3.99926C3.44967 5 3 5.45 3 6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/Notes.d3182957.svg";
export { ForwardRef as ReactComponent };